import { useEffect, useState } from "react";
import { Phone, ShoppingBag } from "lucide-react";
import { Logo } from "./Logo";
import { PHONE, PHONE_LABEL } from "./data";
import { useCart } from "./cart";

const CartButton = () => {
  const { count, setOpen } = useCart();
  return (
    <button onClick={() => setOpen(true)} data-testid="header-cart-button" aria-label="Apri carrello"
      className="relative grid place-items-center w-10 h-10 sm:w-11 sm:h-11 shrink-0 rounded-full border border-[#F4EFE6]/30 text-[#FDFBF7] hover:border-[#E8893F] hover:text-[#E8893F] transition-colors">
      <ShoppingBag className="w-5 h-5" />
      {count > 0 && (
        <span data-testid="header-cart-count" className="absolute -top-1 -right-1 min-w-5 h-5 px-1 grid place-items-center rounded-full bg-[#E8893F] text-[#1A110C] text-[11px] font-bold">{count}</span>
      )}
    </button>
  );
};

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow] duration-500 ${
        scrolled ? "bg-[#1A110C]/85 backdrop-blur-xl shadow-[0_8px_32px_rgba(0,0,0,0.25)]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-8 h-16 sm:h-20 flex items-center justify-between gap-2 sm:gap-4">
        <Logo light />
        <nav className="hidden md:flex items-center gap-8 text-sm text-[#F4EFE6]/80">
          <a href="#prodotti" data-testid="nav-prodotti" className="hover:text-[#E8893F] transition-colors">Prodotti</a>
          <a href="#listino" data-testid="nav-listino" className="hover:text-[#E8893F] transition-colors">Listino</a>
          <a href="#consegna" data-testid="nav-consegna" className="hover:text-[#E8893F] transition-colors">Consegna</a>
          <a href="#legno" data-testid="nav-legno" className="hover:text-[#E8893F] transition-colors">Il legno</a>
          <a href="#contatti" data-testid="nav-contatti" className="hover:text-[#E8893F] transition-colors">Contatti</a>
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
        <CartButton />
        <a
          href={`tel:${PHONE}`}
          data-testid="header-call-now-button"
          className="call-btn group relative flex shrink-0 items-center gap-2 sm:gap-2.5 rounded-full bg-[#E8893F] text-[#1A110C] pl-2 pr-4 sm:pr-5 py-2 font-semibold text-sm hover:bg-[#F4A261] transition-colors"
        >
          <span className="relative grid place-items-center w-8 h-8 rounded-full bg-[#1A110C] text-[#E8893F]">
            <span className="absolute inset-0 rounded-full bg-[#1A110C] animate-ping opacity-30" />
            <Phone className="w-4 h-4 relative transition-transform group-hover:rotate-12" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="uppercase tracking-[0.08em] sm:tracking-[0.14em] text-[11px] whitespace-nowrap">Chiama ora</span>
            <span className="hidden sm:block text-xs font-medium opacity-80">{PHONE_LABEL}</span>
          </span>
        </a>
        </div>
      </div>
    </header>
  );
};
